// extracted by mini-css-extract-plugin
var _1 = "_productManagementDiscountCreateForm-module__container";
var _2 = "_productManagementDiscountCreateForm-module__edit-button";
var _3 = "_productManagementDiscountCreateForm-module__flex-div";
var _4 = "_productManagementDiscountCreateForm-module__flex-span-container";
var _5 = "_productManagementDiscountCreateForm-module__form-container";
var _6 = "_productManagementDiscountCreateForm-module__form-subcontainer";
var _7 = "_productManagementDiscountCreateForm-module__label";
var _8 = "_productManagementDiscountCreateForm-module__label-no-margin";
var _9 = "_productManagementDiscountCreateForm-module__round";
var _a = "_productManagementDiscountCreateForm-module__slider";
var _b = "_productManagementDiscountCreateForm-module__submit-button";
var _c = "_productManagementDiscountCreateForm-module__switch";
export { _1 as "container", _2 as "edit-button", _3 as "flex-div", _4 as "flex-span-container", _5 as "form-container", _6 as "form-subcontainer", _7 as "label", _8 as "label-no-margin", _9 as "round", _a as "slider", _b as "submit-button", _c as "switch" }
